import { TeamLanguage } from './team.type';

export const INITIAL_REEL_STATUS = 'pending';
export const PROCESSING_REEL_STATUS = 'processing';
export const PROCESSED_REEL_STATUS = 'processed';
export const FAILED_REEL_STATUS = 'failed';
export const SOFT_DELETED_REEL_STATUS = 'soft_deleted';
export const PURGED_REEL_STATUS = 'purged';

// NOTE: The slug of the example video used for new steps, see {reelflow-api/config/reelflow.php} for more details
export const EXAMPLE_CONTENT_REEL_SLUG = 'example_content';

const reelStatusList = [
    INITIAL_REEL_STATUS,
    PROCESSING_REEL_STATUS,
    PROCESSED_REEL_STATUS,
    FAILED_REEL_STATUS,
    SOFT_DELETED_REEL_STATUS,
    PURGED_REEL_STATUS,
] as const;

export type ReelStatus = (typeof reelStatusList)[number];

export const REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL = 'real-footage-and-audio';
export const GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL =
    'generated-footage-and-real-audio';
export const GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL =
    'generated-footage-and-audio';
export const REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL =
    'real-footage-and-generated-audio';
export const UNKNOWN_CONTENT_LABEL = 'unknown';

const contentLabelList = [
    UNKNOWN_CONTENT_LABEL,
    REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
] as const;

export type ContentLabel = (typeof contentLabelList)[number];

/**
 * Library table row. The flyover loads the full `Reel` separately.
 */
export type ReelListItem = {
    id: number;
    code: string;
    name: string;
    created_at: string;
    status: ReelStatus;
    creator_name?: string | null;
    thumbnail?: string | null;
    example_reel_slug?: string | null;
    original_filename?: string | null;
    duration?: number | null;
    flow_count?: number;
    published_flow_count?: number;
    unpublished_flow_count?: number;
    content_label: ContentLabel;
    has_reviewed_captions: boolean;
    video_url?: string | null;
};

export type Reel = {
    id: number;
    team_id: number;
    organisation_id: number;
    example_reel_slug?: string | null;
    created_by: number;
    code: string;
    name: string;
    created_at: string;
    updated_at: string;
    content_label: ContentLabel;
    status: ReelStatus;
    data: ClipData;
    video_url: string;
    captions_url: string;
    reviewed_captions_url?: string;
    flow_count?: number;
    published_flow_count?: number;
    unpublished_flow_count?: number;
    creator_name?: string;
    thumbnail?: string;
    screenshot?: string;
    language?: TeamLanguage;
    trim_start?: number | null;
    trim_end?: number | null;
    playback_speed?: number | null;
};

export type ClipData = {
    video: {
        path: string;
        size: number;
        duration: number;
        original_filename?: string;
        original_path?: string;
    };
    // NOTE: The VTT file as it was generated by the pipeline
    captions: {
        path: string;
        size: number;
    };
    // NOTE: The VTT file as it was reviewed and/or edited by the user
    reviewed_captions?: {
        path: string;
        size: number;
    };
    content_label?: ContentLabel;
};

export type VttChunk = {
    startTimeMs: number;
    endTimeMs: number;
    text: string;
};
